import { Actions } from './actions';
import { GET_SETTINGS_SUCCESS, POST_CELL_SETTINGS_SUCCESS } from './constants';

const initialState = {
  loading: false as boolean,
  error: null as Error | null,
  settings: {} as any,
};

type DirectorSettingsState = typeof initialState;

export const directorSettingsReducer = (state: DirectorSettingsState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_SETTINGS_SUCCESS: {
      return {
        ...state,
        settings: action.payload,
      };
    }
    case POST_CELL_SETTINGS_SUCCESS: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    default: {
      return state;
    }
  }
};
